import React, { Fragment } from 'react';
import { FormattedNumber } from 'react-intl';

import { fontSize, colors } from 'styles/cp';

export interface InvoiceItemProps {
  description: string;
  amount: number;
  currency?: string;
  quantity?: number;
}

const InvoiceItem = ({ description, amount, currency, quantity }: InvoiceItemProps) => {
  // Show quantity × price format only if both description exists and quantity > 1
  const shouldShowQuantityPrice = description && quantity && quantity > 1;
  const pricePerUnit = shouldShowQuantityPrice && quantity ? amount / quantity : 0;

  return (
    <Fragment>
      <div className="item-container" aria-label="Invoice item description">
        <div className="space-between flex-row">
          <span className="label left description" title={description}>
            {description}
          </span>
          <span className="label label-data right">
            <FormattedNumber value={amount} style="currency" currency={currency} />
          </span>
        </div>
        {shouldShowQuantityPrice && (
          <div className="quantity-price-row" aria-label="quantity and unit price">
            <span className="quantity-price-label">
              {quantity}&#215;
              <FormattedNumber value={pricePerUnit} style="currency" currency={currency} />
            </span>
          </div>
        )}
      </div>

      <style jsx>{`
        /* Container styles */
        .item-container {
          margin-bottom: 11px;
        }

        /* Layout styles */
        .space-between {
          display: flex;
          justify-content: space-between;
        }
        .flex-row {
          flex-direction: row;
        }

        /* Label styles */
        .label {
          font-size: ${fontSize.xs};
          color: ${colors.gray};
          display: flex;
          font-family: AvenirNextforINTUIT-Regular;
        }
        .left {
          text-align: left;
          max-width: 182px;
          padding-right: 0;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .right {
          text-align: right;
          font-family: AvenirNextforINTUIT-Regular;
          color: ${colors.gray01};
        }

        /* Quantity-price section */
        .quantity-price-row {
          margin: 0;
          text-align: left;
        }
        .quantity-price-label {
          font-size: ${fontSize.xs};
          color: ${colors.gray03};
          font-family: AvenirNextforINTUIT-Regular;
        }

        /* Description tooltip */
        .description {
          position: relative;
        }
        .description:hover {
          cursor: help;
        }
        .description::after {
          content: attr(title);
          display: inline-block;
          position: absolute;
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          background-color: black;
          color: white;
          padding: 0.25rem;
          border-radius: 0.25rem;
          font-size: 0.875rem;
          white-space: pre-line;
          max-width: 200px;
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
        }
        .description:hover::after {
          opacity: 1;
        }
      `}</style>
    </Fragment>
  );
};

export default InvoiceItem;
